import React, { FC } from "react"

import styles from "./index.module.scss"

export const IconHome = () => {
    return (
        <img
            draggable={false}
            className={styles.home}
            src={require("@/assets/imgs/icons/header_home.png")}
            alt=""
        />
    )
}

export const IconMusic: FC<{
    off?: boolean
}> = ({ off }) => {
    return (
        <img
            draggable={false}
            className={styles.music}
            src={
                off
                    ? require("@/assets/imgs/icons/header_sound_off.png")
                    : require("@/assets/imgs/icons/header_sound_on.png")
            }
            style={{
                opacity: off ? 0.5 : 1,
            }}
            alt=""
        />
    )
}

export const IconUser = () => {
    return (
        <img
            draggable={false}
            className={styles.user}
            src={require("@/assets/imgs/icons/header_user.png")}
            alt=""
        />
    )
}

export const IconGift = () => {
    return (
        <img
            draggable={false}
            className={styles.gift}
            src={require("@/assets/imgs/icons/header_gift.png")}
            alt=""
        />
    )
}

export const IconSwitch: FC<{
    onClick?: () => void
}> = ({ onClick }) => {
    return (
        <div className={styles.btnWrapper}>
            <img
                draggable={false}
                onClick={onClick}
                src={require("@/assets/imgs/icons/header_login_switch.png")}
                alt=""
            />
        </div>
    )
}

export const IconLogout: FC<{
    onClick?: any
}> = ({ onClick }) => {
    return (
        <div className={styles.btnWrapper}>
            <img
                draggable={false}
                onClick={onClick}
                src={require("@/assets/imgs/icons/header_login_exit.png")}
                alt=""
            />
        </div>
    )
}
